import { useMemo } from 'react';

import { InsuranceFormDataProps, previewInsuranceData } from '@/components/Forms/Steps/InsuranceData';

import { SERVICE_CODES } from '@/lib/consts';

import { DictionaryPermitType } from '@/api/types';

import { DeclaredDocumentsFormDataProps } from '../../../../../../components/Documents/DeclaredDocumentsCreate';
import {
  AdditionalDocumentFormDataProps,
  previewAdditionalDocument,
} from '../../../../../../components/Forms/Steps/AdditionalDocument';
import {
  ConfirmationOfApplication,
  ConfirmationOfApplicationFormDataProps,
} from '../../../../../../components/Forms/Steps/ConfirmationOfApplication';
import { HealthFormDataProps, previewHealthData } from '../../../../../../components/Forms/Steps/HealthData';
import {
  PersonalAndPassportFormDataProps,
  previewPersonalAndPassportData,
} from '../../../../../../components/Forms/Steps/PersonalAndPassportData';
import {
  PlaceOfResidenceFormDataProps,
  previewPlaceOfResidence,
} from '../../../../../../components/Forms/Steps/PlaceOfResidence';
import {
  TechnicalConditionFormDataProps,
  previewTechnicalCondition,
} from '../../../../../../components/Forms/Steps/TechnicalConditionData';
import { parseFormDataValue } from '../../../../../../helpers/parseFormDataValue';

import { PermitDataFieldName, PermitFormDataProps, previewPermitData } from './Step2';
import { PersonStatusFormDataProps, previewPersonStatus } from './Step5';

interface Props {
  formData: PlaceOfResidenceFormDataProps &
    DeclaredDocumentsFormDataProps &
    AdditionalDocumentFormDataProps &
    TechnicalConditionFormDataProps &
    PersonStatusFormDataProps &
    HealthFormDataProps &
    InsuranceFormDataProps &
    PermitFormDataProps &
    PersonalAndPassportFormDataProps &
    ConfirmationOfApplicationFormDataProps;
  handleInputChange: (name: string, value: unknown) => void;
  permitTypesList: DictionaryPermitType[];
}

const permitCode = [SERVICE_CODES.PURCHASE, SERVICE_CODES.COLD_STEEL_TRANSPORTATION];

const Step10: React.FC<Props> = ({ formData, handleInputChange, permitTypesList }) => {
  const hiddenTechnicalCondition = useMemo(
    () =>
      permitCode.toString().includes(parseFormDataValue(formData[PermitDataFieldName.permitType])?.permitType ?? ''),
    [formData],
  );
  const permitTypeLabel = useMemo(
    () =>
      permitTypesList.find(
        (permitType) => permitType.label === parseFormDataValue(formData[PermitDataFieldName.permitType])?.permitType,
      )?.name,
    [permitTypesList, formData],
  );

  return (
    <ConfirmationOfApplication
      formData={formData}
      handleInputChange={handleInputChange}
      accordionData={[
        previewPermitData({ formData, permitTypeLabel: permitTypeLabel ?? '' }),
        previewPersonalAndPassportData({ formData }),
        previewPlaceOfResidence({ formData }),
        previewPersonStatus({ formData }),
        previewHealthData({ formData }),
        previewInsuranceData({ formData }),
        previewTechnicalCondition({ formData, hiddenTechnicalCondition }),
        previewAdditionalDocument({ formData }),
      ]}
    />
  );
};

export default Step10;
